import ServiceLayout from "@/components/ServiceLayout";
import { QuoteModal } from "@/components/QuoteModal";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";

export default function Ulm() {
  return (
    <ServiceLayout
      title="Umzugsunternehmen in Ulm"
      description="Zuverlässiger Umzugsservice und Möbelmontage in Ulm. Wir bringen Ihr Hab und Gut sicher an den neuen Bestimmungsort."
      image="https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/Zrqvy6cNzSbnzDV55cv1/media/6936df9350387f29d144e356.jpg"
      heroBg="https://vibe.filesafe.space/1781514922662573702/assets/546149f4-7459-4947-b903-70d8d078ed6a.png"
      content={
        <>
          <h2 className="font-heading text-3xl md:text-4xl font-bold uppercase tracking-tight">
            Stressfrei umziehen in Ulm
          </h2>
          <p className="text-lg text-neutral-600">
            Ein Umzug nach oder innerhalb von Ulm erfordert gute Planung. Mit unserem erfahrenen Team an Ihrer Seite können Sie sich entspannt zurücklehnen. Wir übernehmen den sicheren Transport, die Demontage und Montage Ihrer Möbel.
          </p>
          <p className="text-lg text-neutral-600">
            Dank unserer modernen Transporter und dem bestens geschulten Personal garantieren wir einen reibungslosen Ablauf – vom ersten Karton bis zum letzten Möbelstück.
          </p>
          <ul className="space-y-3 mt-6">
            {[
              "Professionelle Demontage & Montage",
              "Sicherer Transport Ihrer Möbel",
              "Vollumfänglicher Versicherungsschutz",
              "Transparente Festpreise"
            ].map((item, i) => (
              <li key={i} className="flex items-center gap-3 text-neutral-800 font-medium">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center text-primary shrink-0">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                </div>
                {item}
              </li>
            ))}
          </ul>
        </>
      }
      extendedContent={
        <div className="bg-white">
          <section className="py-16 bg-neutral-50">
            <div className="container mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto space-y-8">
                <div>
                  <h2 className="font-heading text-3xl font-bold mb-4">Ihr kompetentes Umzugsunternehmen in Ulm und Neu-Ulm</h2>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Ein Wohnortswechsel stellt oft eine logistische Meisterleistung dar. Ganz gleich, ob Sie innerhalb von Ulm umziehen, aus einer anderen Stadt in die Donaustadt kommen oder Ulm verlassen – wir von Easy Umzug stehen Ihnen als erfahrenes Umzugsunternehmen zur Seite. Wir nehmen Ihnen den Stress ab und sorgen dafür, dass Ihr Umzug strukturiert, sicher und termingerecht verläuft. Unser bestens geschultes Team behandelt Ihr Inventar mit größter Sorgfalt.
                  </p>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Ulm mit seinem historischen Fischerviertel, den belebten Straßen rund um das Ulmer Münster und den angrenzenden Wohngebieten in Neu-Ulm erfordert bei einem Umzug oft besondere Planung. Wir kennen die örtlichen Gegebenheiten, organisieren bei Bedarf rechtzeitig Halteverbotszonen und wählen die effizientesten Transportwege. So gewährleisten wir einen reibungslosen Ablauf ohne böse Überraschungen am Umzugstag.
                  </p>
                  <div className="pt-4 pb-2 flex flex-col sm:flex-row items-start gap-4">
                    <QuoteModal>
                      <Button size="lg" className="font-bold text-base px-8 py-6 rounded-none bg-primary text-white hover:bg-primary/90 w-full sm:w-auto">
                        Kostenloses Angebot anfordern
                      </Button>
                    </QuoteModal>
                    <Button size="lg" variant="secondary" asChild className="w-full sm:w-auto">
                      <a href="tel:+4915888640762">
                        <Phone className="w-5 h-5 mr-2" />
                        +49 15888 640762
                      </a>
                    </Button>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-8 pt-8">
                  <div className="bg-white p-8 border border-neutral-200">
                    <h3 className="font-heading text-xl font-bold mb-3">Privatumzüge in Ulm</h3>
                    <p className="text-neutral-600 leading-relaxed">
                      Egal ob Single-Apartment, Familienhaus am Eselsberg oder Penthouse-Wohnung in der Stadtmitte – wir bieten Ihnen für Ihren Privatumzug in Ulm maßgeschneiderte Lösungen. Vom reinen Transport bis zum Full-Service-Paket inklusive Einpacken und Möbelmontage richten wir uns ganz nach Ihren Bedürfnissen.
                    </p>
                  </div>
                  <div className="bg-white p-8 border border-neutral-200">
                    <h3 className="font-heading text-xl font-bold mb-3">Firmen- und Büroumzüge</h3>
                    <p className="text-neutral-600 leading-relaxed">
                      Ein Standortwechsel Ihres Unternehmens in Ulm muss schnell und professionell über die Bühne gehen, um Ausfallzeiten zu minimieren. Wir transportieren Ihre IT-Infrastruktur, Akten und Büromöbel sicher und bauen alles am neuen Standort fachgerecht wieder auf.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="py-16 bg-white">
            <div className="container mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto space-y-8">
                <div>
                  <h2 className="font-heading text-3xl font-bold mb-4">Unser Full-Service-Angebot für Ihren Umzug in Ulm</h2>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Wir verstehen uns nicht nur als reine Möbelpacker, sondern als ganzheitlicher Dienstleister rund um Ihren Umzug. Unsere erfahrenen Handwerker übernehmen die professionelle Demontage und Montage Ihrer Möbel. Auch komplexe Schranksysteme oder Einbauküchen werden von uns fachgerecht ab- und am neuen Standort in Ulm wieder aufgebaut.
                  </p>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Zu unserem umfassenden Service gehören auch Elektro- und Lichtinstallationen. Wir schließen Ihre Deckenlampen sicher an, montieren Elektrogeräte wie Herde oder Waschmaschinen und sorgen dafür, dass in Ihrem neuen Zuhause vom ersten Tag an alles funktioniert. Auf Wunsch übernehmen wir auch Renovierungsarbeiten wie Bodenverlegung oder Pflasterarbeiten, um Ihr altes oder neues Heim perfekt vorzubereiten.
                  </p>
                  <div className="pt-4 pb-2 flex flex-col sm:flex-row items-start gap-4">
                    <QuoteModal>
                      <Button size="lg" className="font-bold text-base px-8 py-6 rounded-none bg-primary text-white hover:bg-primary/90 w-full sm:w-auto">
                        Jetzt beraten lassen
                      </Button>
                    </QuoteModal>
                  </div>
                </div>

                <div className="bg-primary/5 p-8 border-l-4 border-primary mt-8">
                  <h3 className="font-heading text-2xl font-bold mb-3">Sicherheit und Festpreisgarantie</h3>
                  <p className="text-neutral-700 leading-relaxed">
                    Wir legen großen Wert auf Transparenz und Fairness. Nach einer kostenlosen Besichtigung Ihres Umzugsguts in Ulm erstellen wir Ihnen ein verbindliches Festpreisangebot. So haben Sie die volle Kostenkontrolle ohne versteckte Gebühren. Zudem ist Ihr Umzugsgut bei uns während des gesamten Transports und der Montagearbeiten vollumfänglich versichert.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="py-16 bg-neutral-950 text-white">
            <div className="container mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto text-center">
                <h2 className="font-heading text-3xl font-bold mb-6">Ihre Vorteile mit Easy Umzug in Ulm</h2>
                <div className="grid sm:grid-cols-3 gap-8 mt-12 text-left">
                  <div>
                    <div className="w-12 h-12 bg-primary flex items-center justify-center mb-4">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
                    </div>
                    <h3 className="font-bold text-lg mb-2">Regionale Erfahrung</h3>
                    <p className="text-neutral-400">Als Experten für die Region Ulm/Neu-Ulm gewährleisten wir eine optimale Routenplanung und Logistik.</p>
                  </div>
                  <div>
                    <div className="w-12 h-12 bg-primary flex items-center justify-center mb-4">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                    </div>
                    <h3 className="font-bold text-lg mb-2">Kostenlose Besichtigung</h3>
                    <p className="text-neutral-400">Wir beraten Sie vor Ort, schätzen das Volumen ein und erstellen ein maßgeschneidertes Angebot.</p>
                  </div>
                  <div>
                    <div className="w-12 h-12 bg-primary flex items-center justify-center mb-4">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>
                    </div>
                    <h3 className="font-bold text-lg mb-2">Umfassender Service</h3>
                    <p className="text-neutral-400">Mit unseren Handwerksleistungen bieten wir Ihnen weit mehr als nur den reinen Möbeltransport.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      }
    />
  );
}
